import Vue from 'vue'

import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, inputModes, services } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderTitle(h) {
  return h(
    'div',
    {},
    [ this.getTranslate(`${services.recover}.title`) ]
  )
}
function renderPlatformTitle(h) {
  const title = this.globalSettings?.frontend?.title
  if (title) {
    return h(
      'div',
      {
        class: 'text--grey'
      },
      [ title ]
    )
  }
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: {
        [`${services.recover}__header`]: true,
        title: this.viewport.size.width <= 768,
        headline: this.viewport.size.width > 768
      }
    },
    [
      renderTitle.call(this, h),
      renderPlatformTitle.call(this, h)
    ]
  )
}

function renderValidationResult(h) {
  if (this.validation === true && this.state === 'request') {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${services.recover}.contents.validation.request`),
          icon: icons.check_circle,
          color: Colors.success
        }
      }
    )
  }
}
function renderLoginField(h) {
  if (this.validation === undefined) {
    return h(
      components['text-field'],
      {
        props: {
          value: this.login,
          disabled: this.loading,
          label: this.getTranslate(`${services.recover}.labels.login`),
          mode: inputModes['line-label'],
          rounded: true,
          required: true,
          clearable: true,
          autofocus: true,
          details: false
        },
        on: {
          input: event => {
            this.login = event
          }
        }
      }
    )
  }
}
function renderPasswordField(h) {
  if (this.validation === true && this.state === 'key') {
    return h(
      components['text-field'],
      {
        props: {
          name: 'password',
          value: this.password,
          label: this.getTranslate(`${services.recover}.labels.password`),
          hint: this.getTranslate(`${services.recover}.hints.password`),
          disabled: this.loading,
          type: this.passwordVisibility ? 'text' : 'password',
          afterIcon: this.passwordVisibility ? icons.visibility_off : icons.visibility,
          afterIconCallback: () => {
            this.passwordVisibility = !this.passwordVisibility
          },
          mode: inputModes['line-label'],
          rounded: true,
          required: true,
          autofocus: true,
          clearable: true
        },
        on: {
          input: event => {
            this.password = event
          }
        }
      }
    )
  }
}
function renderBody(h) {
  return h(
    components.card,
    {
      class: `${services.recover}__body`,
      props: {
        outline: true,
        rounded: true,
        minWidth: this.viewport.size.width < 768 ? 360 : 400,
        maxWidth: this.viewport.size.width < 768 ? 360 : 400
      }
    },
    [
      renderLoginField.call(this, h),
      renderPasswordField.call(this, h),
      renderValidationResult.call(this, h)
    ]
  )
}

function renderLoginButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.signin'),
        mode: buttonModes.flat
      },
      on: {
        click: () => {
          Vue.router.push({ name: 'login' })
        }
      }
    }
  )
}
function renderResetButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate(`${services.recover}.buttons.reset`),
        mode: buttonModes.filled,
        color: Colors.primary,
        loading: this.loading,
        disabled: this.$buttonDisabled
      },
      on: {
        click: () => {
          if (this.$key) {
            this.changePassword()
          } else {
            this.requestRecover()
          }
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${services.recover}__footer`
    },
    [
      renderLoginButton.call(this, h),
      renderResetButton.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.recover}`
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
